import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { GeographicalLocation } from 'src/app/models/localization/geographical-location.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { StreetType } from 'src/app/models/localization/street-type.model';
import { Basic } from 'src/app/core/models/basic.model';
import { VirtualGroupingType } from 'src/app/models/master/virtual-grouping-type.model';
import { MasterService } from 'src/app/services/master.service';

@Component({
  selector: 'client-address-section',
  templateUrl: './client-address-section.component.html',
  styleUrls: ['./client-address-section.component.scss']
})
export class ClientAddressSectionComponent implements OnInit {
  @Input() expanded: boolean = true;
  @Input() title: string;
  /**Es cliente? */
  @Input() isClient: boolean;
  /**Componente padre */
  @Input() parentComponent: string;
  @Input() disabled: boolean = false;
  /*Lista de departamentos para la dirección de ocurrencia del reclamo*/
  departmentList: GeographicalLocation[] = [];
  /*Lista de provincias para la dirección de ocurrencia del reclamo */
  provinceList: GeographicalLocation[] = [];
  /*Lista de distritos para la dirección de ocurrencia del reclamo */
  districtList: GeographicalLocation[] = [];
  /*Lista de tipos de calle */
  streetTypeList: StreetType[] = [];
  /*Lista de tipos de edificio */
  buildingTypeList: Basic<string>[] = [];
  /*Lista de tipos de vivienda */
  houseTypeList: Basic<string>[] = [];
  /*Lista de tipos de interiores */
  interiorTypeList: Basic<string>[] = [];
  /*Lista de tipos de comite */
  physicalGroupingTypeList: Basic<string>[] = [];
  /*Lista de tipos de grupo de vivienda */
  virtualGroupingTypeList: VirtualGroupingType[] = [];
  formGroup: FormGroup;

  ConcatAdress:string;
  constructor(private formBuilder: FormBuilder,
    private localizationService: LocalizationService,
    private masterService: MasterService) { }

  ngOnInit() {
    this.createForm();
    this.listBuildingTypes();
    this.listHouseTypes();
    this.listInteriorTypes();
    this.listPhysicalGroupingTypes();
    this.listVirtualGroupingTypes();
    this.listStreetTypes();

    //if (!this.isClient) this.listDepartments();
    this.listDepartments();
    if (this.disabled) this.formGroup.disable();
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      streetType: [, [Validators.maxLength(10)]],
      streetDescription: [, [Validators.maxLength(60)]],
      streetNumber: [, [Validators.maxLength(10)]],
      buildingType: [,[Validators.maxLength(10)]],
      buildingDescription: [,[Validators.maxLength(18)]],
      houseType: [,[Validators.maxLength(10)]],
      houseDescription: [,[Validators.maxLength(37)]],
      houseFloorNumber: [,[Validators.maxLength(10)]],
      interiorType: [,[Validators.maxLength(10)]],
      interiorDescription: [,[Validators.maxLength(8)]],
      physicalGroupingType: [,[Validators.maxLength(10)]],
      physicalGroupingDescription: [,[Validators.maxLength(38)]],
      virtualGroupingType: [,[Validators.maxLength(10)]],
      virtualGroupingDescription: [,[Validators.maxLength(40)]],
      block: [,[Validators.maxLength(40)]],
      lot: [,[Validators.maxLength(40)]],
      districtCode: [],
      provinceCode: [],
      departmentCode: [],
      region: [],
      postalCode: [,[Validators.maxLength(10)]]
    }, { validators: this.lotAndBlockOrStreetNumberValidator })
  }

  get f() { return this.formGroup.controls; }

  async fillForm(accountBasicData: AccountBasicData) {
    this.formGroup.patchValue({
      streetType: accountBasicData.supplyAddress.streetType,
      streetDescription: accountBasicData.supplyAddress.streetDescription,
      streetNumber: accountBasicData.supplyAddress.streetNumber,
      buildingType: accountBasicData.supplyAddress.buildingType,
      buildingDescription: accountBasicData.supplyAddress.buildingDescription,
      houseType: accountBasicData.supplyAddress.houseType,
      houseDescription: accountBasicData.supplyAddress.houseDescription,
      houseFloorNumber: accountBasicData.supplyAddress.houseFloorNumber,
      interiorType: accountBasicData.supplyAddress.interiorType,
      interiorDescription: accountBasicData.supplyAddress.interiorDescription,
      physicalGroupingType: accountBasicData.supplyAddress.physicalGroupingType,
      physicalGroupingDescription: accountBasicData.supplyAddress.physicalGroupingDescription,
      virtualGroupingType: accountBasicData.supplyAddress.virtualGroupingType,
      virtualGroupingDescription: accountBasicData.supplyAddress.virtualGroupingDescription,
      block: accountBasicData.supplyAddress.block,
      lot: accountBasicData.supplyAddress.lot,
      departmentCode: accountBasicData.supplyAddress.districtCode != "" ? accountBasicData.supplyAddress.districtCode.substring(0, 2) + '0000' : "",
      provinceCode: accountBasicData.supplyAddress.districtCode != "" ? accountBasicData.supplyAddress.districtCode.substring(0, 4) + '00' : "",
      districtCode: accountBasicData.supplyAddress.districtCode
    });
    
    await this.listDepartments();
    await this.listProvinces(this.formGroup.get('provinceCode').value);
    await this.listDistricts(this.formGroup.get('districtCode').value);
  }

  public isnullString(text:string, withSpace:boolean) : string
  {
    if(withSpace)
      return  text ? (text + " ") : "";
    else
      return  text ? text  : "";
  }
  public concatStreetAddress(){

    let _streetType = this.formGroup.get('streetType').value ? this.streetTypeList.find(q=>q.code === this.formGroup.get('streetType').value).description : '';
    let _streetDescription = this.formGroup.get('streetDescription').value ? this.formGroup.get('streetDescription').value : '';
    let _streetNumber = this.formGroup.get('streetNumber').value ? this.formGroup.get('streetNumber').value : '';
    let _houseFloorNumber = this.formGroup.get('houseFloorNumber').value ? this.formGroup.get('houseFloorNumber').value : '';

    let _interiorType = this.formGroup.get('interiorType').value ? this.interiorTypeList.find(q=>q.code === this.formGroup.get('interiorType').value).description : '';

    let _interiorDescription = this.formGroup.get('interiorDescription').value ? this.formGroup.get('interiorDescription').value : '';

    let _physicalGroupingType = this.formGroup.get('physicalGroupingType').value ? this.physicalGroupingTypeList.find(q=>q.code === this.formGroup.get('physicalGroupingType').value).description : '';

    let _physicalGroupingDescription = this.formGroup.get('physicalGroupingDescription').value ? this.formGroup.get('physicalGroupingDescription').value : '';
    let _block = this.formGroup.get('block').value ? this.formGroup.get('block').value : '';
    let _lot = this.formGroup.get('lot').value ? this.formGroup.get('lot').value : '';
    let _virtualGroupingType = this.formGroup.get('virtualGroupingType').value ? this.virtualGroupingTypeList.find(q=>q.code === this.formGroup.get('virtualGroupingType').value).description : '';
    let _virtualGroupingDescription = this.formGroup.get('virtualGroupingDescription').value ? this.formGroup.get('virtualGroupingDescription').value : '';

    let _departmentCode = '';
    let itemDepartamento = this.departmentList.find(q=>q.code === this.formGroup.get('departmentCode').value);
    if (itemDepartamento != null){
      _departmentCode = this.formGroup.get('departmentCode').value ? this.departmentList.find(q=>q.code === this.formGroup.get('departmentCode').value).description : '';
    }

    let _provinceCode = '';
    let itemProvincia = this.provinceList.find(q=>q.code === this.formGroup.get('provinceCode').value);
    if (itemProvincia != null){
      _provinceCode = this.formGroup.get('provinceCode').value ? this.provinceList.find(q=>q.code === this.formGroup.get('provinceCode').value).description : '';
    }

    let _districtCode = '';
    let itemDistrito = this.districtList.find(q=>q.code === this.formGroup.get('districtCode').value);
    if (itemDistrito != null){
      _districtCode = this.formGroup.get('districtCode').value ? this.districtList.find(q=>q.code === this.formGroup.get('districtCode').value).description : '';
    }

    this.ConcatAdress = this.isnullString(_streetType, true) + 
    this.isnullString(_streetDescription, true) +
    this.isnullString(_streetNumber, true) +
    (_houseFloorNumber ? "Piso " : "") +
    this.isnullString(_houseFloorNumber, true) +
    this.isnullString(_interiorType, true) +
    this.isnullString(_interiorDescription, true) +
    this.isnullString(_physicalGroupingType, true) +
    this.isnullString(_physicalGroupingDescription, true) +
    (_block ? "Mz " : "") +
    this.isnullString(_block, true) +
    (_lot ? "Lt. " : "") +
    this.isnullString(_lot, true) +
    this.isnullString(_virtualGroupingType, true) +
    this.isnullString(_virtualGroupingDescription, true) +
    this.isnullString(_departmentCode, true) +
    this.isnullString(_provinceCode, true) + 
    this.isnullString(_districtCode, false)
  }

  lotAndBlockOrStreetNumberValidator(abstractControl: AbstractControl) {
    if (true) {
      return null;
    } else return { lotAndBlockOrStreetNumberIsNeeded: true };
  }
  async listDepartments() {    
    await this.localizationService.listDepartments().subscribe(response => {
      this.departmentList = response.data.filter(x => x.gis);
    });
  }
  async listProvinces(preSelectedProvince?: string) {    
    let response = await this.localizationService.listProvinces(this.formGroup.get('departmentCode').value).toPromise();
    this.provinceList = response.data.filter(x => x.gis);

    if (preSelectedProvince) this.formGroup.get('provinceCode').patchValue(preSelectedProvince);
    this.districtList = [];
  }
  async listDistricts(preSelectedDistrict?: string) {    
    let response = await this.localizationService.listDistricts(this.formGroup.get('provinceCode').value).toPromise();
    this.districtList = response.data.filter(x => x.gis);
    if (preSelectedDistrict) {
      this.formGroup.get('districtCode').patchValue(preSelectedDistrict);
      this.districtChanged();
    }

  }
  listStreetTypes() {
    this.masterService.listStreetTypes().subscribe(response => {
      this.streetTypeList = response.data;
    });
  }
  listBuildingTypes() {
    this.masterService.listBuildingTypes().subscribe(response => {
      this.buildingTypeList = response.data;
    });
  }
  listHouseTypes() {
    this.masterService.listHouseTypes().subscribe(response => {
      this.houseTypeList = response.data;
    });
  }
  listInteriorTypes() {
    this.masterService.listInteriorTypes().subscribe(response => {
      this.interiorTypeList = response.data;
    });
  }
  listPhysicalGroupingTypes() {
    this.masterService.listPhysicalGroupingTypes().subscribe(response => {
      this.physicalGroupingTypeList = response.data;
    });
  }
  listVirtualGroupingTypes() {
    this.masterService.listVirtualGroupingTypes().subscribe(response => {
      this.virtualGroupingTypeList = response.data;
    });
  }
  districtChanged() {
    this.districtList.filter(x => x.code == this.formGroup.get('districtCode').value)
      .map(district => {
        this.formGroup.patchValue({
          region: district.region,
          postalCode: district.postalCode
        })
      });
  }
}
